<template>
  <div class="otpPage">
    <header class="otpTop">
      <img class="logo" :src="logoSrc" alt="Partai Perindo" />
    </header>

    <div class="otpWrap">

      <div class="sections">
        <div class="backRow">
          <button class="backBtn" type="button" @click="$emit('back')">
            <span class="backIcon">‹</span>
            <span>Kembali</span>
          </button>
        </div>
        <section class="card">
          <div class="otpIcon">
            <img :src="otpIconSrc" alt="" />
          </div>

          <h1 class="title">Masukkan Kode OTP</h1>
          <p class="subtitle">
            Kode OTP telah dikirimkan ke nomor kamu
            <span class="phone">{{ maskedPhone }}</span>
            <!-- <small class="timerText">kode OTP anda berlaku selama {{ timeText }}</small> -->
          </p>

          <div class="boxes" :class="{ shake: shakeAnim }">
            <input
              v-for="(d, idx) in digits"
              :key="idx"
              :ref="el => setOtpRef(el, idx)"
              class="box"
              :class="{
                filled: !!digits[idx],
                active: activeIndex === idx,
                error: state === 'error'
              }"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              :value="digits[idx]"
              @focus="activeIndex = idx"
              @input="onInput(idx, $event)"
              @keydown="onKeydown(idx, $event)"
              @paste="onPaste($event)"
            />
          </div>

          <button class="btn" type="button" :disabled="!canVerify || loading" @click="onVerifyClick">
            {{ loading ? "Memverifikasi..." : "Verifikasi" }}
          </button>

          <div class="resend">
            <span>Tidak menerima kode?</span>
            <button class="resendBtn" type="button" :disabled="cooldown > 0" @click="onResend">
              {{ otpTimer.minutes > 0 || otpTimer.seconds > 0 ? `Kirim Ulang ${timeText}` : "Kirim Ulang" }}
            </button>
          </div>

          <p v-if="state === 'error' && message" class="errorText">{{ message }}</p>
        </section>
      </div>

      <footer class="footer">
        <span>Copyright 2025 Perindo</span>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtpSection",
  props: {
    logoSrc: { type: String, default: "" },
    otpIconSrc: { type: String, default: "" },
    phone: { type: String, default: "" },

    type: { type: String, default: "daftar" },
    validUntil: { type: String, default: "" },

    loading: { type: Boolean, default: false },
    state: { type: String, default: "default" }, // default | error
    message: { type: String, default: "" },
  },
  data() {
    return {
      digits: ["", "", "", ""],
      otpRefs: [],
      activeIndex: 0,
      cooldown: 60,
      timer: null,
      shakeAnim: false,

      otpTimer: { minutes: 0, seconds: 0 },
      interval: null,
    };
  },
  computed: {
    code() {
      return this.digits.join("");
    },
    canVerify() {
      return this.code.length === 4 && !this.digits.includes("");
    },
    maskedPhone() {
      const raw = (this.phone || "").replace(/\D/g, "");
      if (!raw) return "+62***********";
      const head = raw.slice(1, 7);
      return `+62${head}xxxx`;
    },

    timeText() {
      const m = this.otpTimer.minutes > 9 ? this.otpTimer.minutes : "0" + this.otpTimer.minutes;
      const s = this.otpTimer.seconds > 9 ? this.otpTimer.seconds : "0" + this.otpTimer.seconds;
      return `${m} : ${s}`;
    },
  },
  watch: {
    state(newVal) {
      if (newVal === "error") {
        this.shakeAnim = true;
        setTimeout(() => (this.shakeAnim = false), 350);
      }
    },
  },
  mounted() {
    this.startCooldown();
    this.$nextTick(() => setTimeout(() => this.focusAt(0), 0));

     // interval countdown otp valid
    this.interval = setInterval(() => {
    this.calculateTimeLeft(this.validUntil || localStorage.getItem("valid"));
  }, 1000);
  },
  beforeUnmount() {
    this.stopCooldown();
    if (this.interval) clearInterval(this.interval);
  },
  methods: {
    setOtpRef(el, idx) {
      if (el) this.otpRefs[idx] = el;
    },
    focusAt(i) {
      const el = this.otpRefs[i];
      if (!el) return;
      el.focus();
      el.setSelectionRange?.(1, 1);
    },

    playShake() {
      this.shakeAnim = true;
      setTimeout(() => (this.shakeAnim = false), 350);
    },

    onInput(idx, e) {
      const val = (e.target.value || "").replace(/\D/g, "");

      this.$emit("change", this.code);

      if (!val) {
        this.digits[idx] = "";
        this.$emit("change", this.code);
        return;
      }

      this.digits[idx] = val.slice(-1);
      this.$emit("change", this.code);

      if (idx < this.digits.length - 1) {
        this.$nextTick(() => this.focusAt(idx + 1));
      }
    },

    onKeydown(idx, e) {
      if (e.key === "Backspace") {
        if (this.digits[idx]) {
          this.digits[idx] = "";
          this.$emit("change", this.code);
          return;
        }
        if (idx > 0) {
          this.focusAt(idx - 1);
          this.digits[idx - 1] = "";
          this.$emit("change", this.code);
        }
      }
    },

    onPaste(e) {
      e.preventDefault();
      const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4);
      if (!text) return;

      for (let i = 0; i < 4; i++) this.digits[i] = text[i] || "";

      this.$emit("change", this.code);

      this.$nextTick(() => this.focusAt(Math.min(text.length, 3)));
    },

    onVerifyClick() {
      if (!this.canVerify || this.loading) return;

      this.$emit("submit", this.code);
    },

    startCooldown() {
      this.stopCooldown();
      this.timer = setInterval(() => {
        if (this.cooldown <= 0) {
          this.stopCooldown();
          return;
        }
        this.cooldown -= 1;
      }, 1000);
    },
    stopCooldown() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    },

    onResend() {
      if (this.cooldown > 0) return;

      this.startCooldown();
      this.digits = ["", "", "", ""];
      this.$emit("change", "");
      this.$nextTick(() => this.focusAt(0));

      this.$emit("resend");
    },

    calculateTimeLeft(endTime) {
      if (!endTime) return;

      const diff = +new Date(endTime) - +new Date();
      if (diff > 0) {
        this.otpTimer.minutes = Math.floor((diff / 1000 / 60) % 60);
        this.otpTimer.seconds = Math.floor((diff / 1000) % 60);
      } else {
        this.otpTimer.minutes = 0;
        this.otpTimer.seconds = 0;
      }
    },
  },
};
</script>

<style scoped>
.sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
}
.otpPage {
  min-height: 100vh;
  background: #ffffff;
}

.otpTop {
  padding: 18px 18px 0;
}

.logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}

.otpWrap {
  min-height: calc(100vh - 60px);
  display: grid;
  place-items: center;
  padding: 10px 16px 18px;
}

.backRow {
  width: min(520px, 100%);
  margin-bottom: 10px;
}

.backBtn {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #223f80;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 13px;
}

.backIcon {
  font-size: 18px;
  line-height: 1;
}

.card {
  width: min(520px, 100%);
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(17, 24, 39, 0.08);
  padding: 26px 80px 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.otpIcon {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  margin-top: 2rem;
}

.otpIcon img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.title {
  margin: 0 0 6px;
  font-size: 32px;
  font-weight: 700;
  color: #393B4A;
  margin-bottom: -1rem
}

.subtitle {
  margin: 0 0 18px;
  font-size: 14px;
  color: #4F515E;
}

.phone {
  font-weight: 800;
  color: #374151;
}

.boxes {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 8px 0 16px;
}

.box {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  background: #f3f4f6;
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  color: #374151;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
}

.box.filled {
  background: #eef2f7;
}

.box:focus,
.box.active {
  border-color: #7b61ff;
}

.box.error {
  border-color: #f85f35;
  color: #f85f35;
}

.btn {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-weight: 800;
  cursor: pointer;
  background: #223f80;
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(34, 63, 128, 0.18);
}

.btn:disabled {
  background: #eef2f7;
  color: #9ca3af;
  box-shadow: none;
  cursor: not-allowed;
}

.resend {
  margin-top: 14px;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  justify-content: center;
  gap: 6px;
}

.resendBtn {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #223f80;
  font-weight: 800;
}

.resendBtn:disabled {
  cursor: not-allowed;
  color: #9ca3af;
}

.errorText {
  margin: 10px 0 0;
  font-size: 12px;
  color: #f85f35;
  font-weight: 700;
}

.footer {
  width: min(520px, 100%);
  margin-top: 22px;
  color: #9ca3af;
  font-size: 12px;
  text-align: center;
}

/* shake anim */
.shake {
  animation: shake 0.35s ease-in-out;
}

@keyframes shake {
  0% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
  100% { transform: translateX(0); }
}

@media (max-width: 980px) {
  .box {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }

  .card {
    padding: 26px 40px 40px;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 12px;
  }
}
</style>
